<template>
    <div class="order-result">
        <div class="order-result-block-1">
            <div class="order-result-block-1__col-1">
                <div class="order-result-block-1__text-container text-container">
                    <h3 v-if="mode==='private'">Dein Bio-Abo</h3>
                    <h3 v-else-if="subscriptionType">{{ subscriptionType.name }}-Korb</h3>
                    <p>Aus den Angaben ergibt sich folgende Abo-Empfehlung:</p>
                </div>
            </div>
            <div class="order-result-block-1__col-2">

                <results-summary />

                <!-- summary block -->
                <div class="order-result-block-1__link-container">
                    <a
                        href="#"
                        @click.prevent="togglePriceSummaryModalVisible"
                        class="order-result-block-1__link-info"
                    >
                        Preiszusammenstellung
                    </a>
                    <a
                        href="#"
                        class="order-result-block-1__link-edit"
                        @click.prevent="toggleEditModalVisible"
                    >
                        Abo anpassen
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import priceMixin from '../mixins/priceMixin';
import filters from '../mixins/filters';
import ResultsSummary from './ResultsSummary.vue';

// import {
//     getTotalWeightByPeople,
//     getTotalWeightByPeoplePrivate,
//     getTotalWeightRounded,
// } from '../calculations';


export default {
    components: {
        ResultsSummary,
    },
    mixins: [
        priceMixin,
        filters,
    ],
    computed: {
        ...mapState({
            baskets: state => state.baskets,
            appetite: state => state.appetite,
            people: state => state.people,
            orderableSubscriptionTypes: state => state.orderable.product_groups,
            subscriptionType: state => state.subscriptionType,
            earlyInvoice: state => state.earlyInvoice,
            earlyDeliveryFee: state => state.orderable.earlyDeliveryFee,
            intervals: state => state.intervals,
            orderableIntervals: state => state.orderable.intervals,
            mode: state => state.mode,
            privateDeliveryDay: state => state.privateDeliveryDay,
            deliveryFee: state => state.orderable.deliveryFee,
        }),
        ...mapGetters([
            'amounts',
            'appetites',
            'orderableBaskets',
            'groupedBaskets',
            'allBaskets',
            'sortedBasketsMonday',
            'sortedBbasketsWednesday',
            'subscriptionType',
        ]),
        // totalWeightTemp() {
        //     if (this.mode === 'private') {
        //         return getTotalWeightByPeoplePrivate(this.baskets);
        //     }
        //     const totalWeight = getTotalWeightByPeople(this.appetites, this.appetite, this.people);
        //     return totalWeight;
        // },
        // totalWeightTempRounded() {
        //     const totalWeight = getTotalWeightRounded(this.totalWeightTemp);
        //     return totalWeight;
        // },
    },
    methods: {
        toggleEditModalVisible() {
            this.$store.commit('toggleEditModalVisible');
        },
        togglePriceSummaryModalVisible() {
            this.$store.commit('togglePriceSummaryModalVisible');
        },
    },
};
</script>



// WEBPACK FOOTER //
// Results.vue?0380b65b